import { Box, Typography, Grid } from '@mui/material';
import React from 'react';
import { Typography700 } from 'views/common/components';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';
import StyledBox from 'views/rebranded-module/tours-module/TourViewV2/components/TourTitleSection/TourTitleSection.styles';
import { Share } from 'views/rebranded-module/common/components';

const TourTitleSection = (props) => {
  const { cmsData, tour } = props;

  return (
    <StyledBox>
      <Grid container spacing={4} alignItems="center">
        <Grid item xl={8.5} lg={7.5} md={8} sm={9.5}>
          <Typography700
            variant="overline2"
            component="p"
            color="primary"
            mb={2}>
            {interpolateString(cmsData.TourDetailsPage.tourTypeText, {
              type: tour.tour_type.name,
            })}
          </Typography700>
          <Typography variant="h6" component="h1">
            {tour.name}
          </Typography>
        </Grid>
        <Grid item xl={3.5} lg={4.5} md={4} sm={2.5}>
          <Box display="flex" justifyContent="flex-end">
            <Share
              content={cmsData.ShareLinkComponent}
              journeyName={tour.name}
            />
            {/* <Button
          className="showDESKTOP"
          variant="text"
          color="secondary"
          startIcon={<RiHeart3Line />}>
          {cmsData.TourDetailsPage.save}
        </Button>
        <IconButton className="showTABLET" color="secondary">
          <RiHeart3Line />
        </IconButton> */}
          </Box>
        </Grid>
      </Grid>
    </StyledBox>
  );
};

export { TourTitleSection };
